import Vue from 'vue'
import Velocity from 'velocity-animate'

Vue.prototype.$velocity = Velocity
